import { Box, Modal } from '@mui/material';
import React, { useState } from 'react';
import CloseIcon from '../../assets/svg/closeIcon';
import Loader from '../../Components/Loader/Loader';

function NewOrderPopup({
    showPopup,
    setShowPopup,
    selectedOrder,
    handleAcceptOrder,
    handleDeclineOrder, 
    items,
    loading,
    handlePrintNow,
}) {
    const [animateModal, setAnimateModal] = useState(false);
    const [closing, setClosing] = useState(false);

    setTimeout(() => {
        setAnimateModal(true);
    }, 100);

    const handleClose = () => {
        setShowPopup(false);
    };

    return (
        <div>
            <Modal
                open={showPopup}
                onClose={() => {
                    setClosing(true);
                    setShowPopup(false);
                }}
                style={{
                    backdropFilter: 'blur(10px)',
                    backgroundColor: '#2C3142B2 !important',
                }}
            >
                <Box
                    className={`new-orders-popup-container ${animateModal ? 'animate1' : ''} ${closing ? 'close' : ''}`}
                >
                    <div className="new-orders-popup">
                        {loading && <Loader />}
                     
                        <div className="new-orders-popup-top1-background">
                            <p className="new-orders-popup-order-id-text">
          Order ID: <span className="new-orders-popup-order-id">{selectedOrder?.order?.ID}</span>
                            </p>

                            <div className="new-orders-popup-top1-right">
                                <p className="new-orders-popup-time">{selectedOrder?.time}</p>
                                <p className="new-orders-popup-time">{selectedOrder?.date}</p>
                            </div>
                            <CloseIcon
                                size={30}
                                color='white'
                                onClick={handleClose}
                                className='close-icon'
                            />
                        </div>
                        {!loading && (
                            <div className="new-orders-popup-top2">
                                <div className="new-orders-popup-headings-container">
                                    <div className="new-orders-popup-item-id">
                                        <p className="new-orders-popup-item-text">Item</p>
                                    </div>
                                    <div className="new-orders-popup-qty-container">
                                        <p className="new-orders-popup-qty-text">Qty</p>
                                        <p className="new-orders-popup-price-text">Price</p>
                                    </div>
                                </div>

                                <div className="new-orders-popup-horizontal-line"></div>

                                <div className="new-orders-popup-items-container">
                                    {items?.map((item, index) => (
                                        <div key={index} className="new-orders-popup-item-container">
                                            <p className="new-orders-popup-item-id">{item?.Menu_Item_Name}</p>
                                            <div className="new-orders-popup-qty-container">
                                                <p className="new-orders-popup-item-qty">{item?.Quantity}</p>
                                                <p className="new-orders-popup-item-price">$ {item?.Menu_Item_Price}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="new-orders-popup-horizontal-line"></div>

                                {selectedOrder?.order?.cooking_instructions && (
                                    <div className="instruction-section">
                                        <h6 className="new-orders-popup-instructions-heading">Cooking Instructions : </h6>
                                        <p className="new-orders-popup-instructions-content">
                                            {selectedOrder?.order?.cooking_instructions}
                                        </p>
                                    </div>
                                )}
                                {(() => {
                                    const instructions = selectedOrder?.order?.delivery_instructions;
                                    try {
                                        const parsedInstructions = JSON.parse(instructions);
                                        if (Array.isArray(parsedInstructions) && parsedInstructions?.length > 0) {
                                            return (
                                                <div className="instruction-section">
                                                    <h6 className="new-orders-popup-instructions-heading">Delivery Instructions :</h6>
                                                    <p className="new-orders-popup-instructions-content">
                                                        {parsedInstructions.join(', ')}
                                                    </p>
                                                </div>
                                            );
                                        }
                                    } catch (e) {
                                        // Optional: Handle invalid JSON or fallback display
                                    }
                                    return null;
                                })()}
                                <div className="new-orders-popup-btns-container">
                                    <button
                                        className="new-orders-popup-btn decline-btn"
                                        onClick={handleDeclineOrder}
                                    >
                Decline
                                    </button>
                                    <button
                                        className="new-orders-popup-btn"
                                        onClick={handlePrintNow}
                                    >
                Print Now (RawBT)
                                    </button>
                                    <button
                                        className="new-orders-popup-btn accept-order-btn"
                                        onClick={handleAcceptOrder}
                                    >
                Accept Order
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </Box>
            </Modal>

        </div>
    );
}

export default NewOrderPopup;
